import { styles } from "../styles";
import { getPmStatus, getNextPmDate } from "../utils/pm";
import BackButton from "../components/BackButton";

export default function PmListPage({
  mode,
  customers,
  setSelectedCustomer,
  setSelectedLocation,
  setSelectedEquipment,
  setSelectedContactLocation,
  onBack,
}) {
  const allEquipment = customers.flatMap((customer) =>
    (customer.locations || []).flatMap((location) =>
      (location.equipment || []).map((equipment) => ({
        ...equipment,
        customerId: customer.id,
        customerName: customer.name,
        locationId: location.id,
        locationName: location.name,
      }))
    )
  );

  const filtered = allEquipment.filter((equipment) => {
    const status = getPmStatus(equipment);
    return mode === "overdue" ? status?.overdue : status?.dueSoon;
  });

  const goToEquipment = (equipment) => {
    const customer = customers.find((c) => c.id === equipment.customerId);
    const location = customer?.locations.find(
      (l) => l.id === equipment.locationId
    );
    const realEquipment = location?.equipment.find(
      (e) => e.id === equipment.id
    );

    setSelectedCustomer(customer);
    setSelectedLocation(location);
    setSelectedEquipment(realEquipment);
    setSelectedContactLocation(null);
  };

  return (
    <>
      <BackButton onClick={onBack} />

      <h2>{mode === "overdue" ? "PM Overdue" : "PM Due Soon"}</h2>

      {filtered.length === 0 ? (
        <p style={{ color: "#666" }}>
          {mode === "overdue"
            ? "No equipment is currently overdue for PM."
            : "No equipment has a PM due within 30 days."}
        </p>
      ) : (
        filtered.map((equipment) => (
          <div key={equipment.id} style={styles.card}>
            <strong>{equipment.type}</strong>
            <br />
            <strong>Category:</strong> {equipment.category}
            <br />
            <strong>Last PM:</strong> {equipment.lastPmDate || "-"}
            <br />
            <strong>Customer:</strong> {equipment.customerName}
            <br />
            <strong>Location:</strong> {equipment.locationName}
            <br />
            <strong>Frequency:</strong>{" "}
            {equipment.pmFrequencyDays
              ? `${equipment.pmFrequencyDays} days`
              : "-"}
            <br />
            <strong>Next PM Due:</strong>{" "}
            {getNextPmDate(equipment.lastPmDate, equipment.pmFrequencyDays)}
            <br />

            <button
              style={styles.button}
              onClick={() => goToEquipment(equipment)}
            >
              Go To Equipment
            </button>
          </div>
        ))
      )}
    </>
  );
}
